import { Injectable, NgZone } from '@angular/core';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class MobileDetectorProvider {
  private widthBreakpoint: number = 768;

  public isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(window.innerWidth < this.widthBreakpoint);

  constructor(private ngZone: NgZone) {
    window.onresize = (e) => {
      ngZone.run(() => {
        this.isMobile.next(window.innerWidth < this.widthBreakpoint);
      });
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/mobile-detector.ts